import React from 'react';

function NoMatch() {
  return (
      <div className='noMatch'>
        404
      </div>
  );
}

export default NoMatch;
